module.exports = __webpack_public_path__ + "static/media/bishop_logo.34ef315d.svg";